export const robotTutorialsKeys = {
  allRobots: ['tutorials'] as const,
  tutorials: (robotId: string) =>
    [...robotTutorialsKeys.allRobots, robotId] as const,
};
